import React from 'react';
import { logSystemError } from '../firebase/systemLogger';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorId: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Generate a unique Error ID for runtime crashes
    const chars = 'abcdef0123456789';
    let result = '';
    for (let i = 0; i < 12; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    const errorId = `ER500-${result.toUpperCase()}`;
    this.setState({ errorId });

    // Log the crash to Admin Portal
    logSystemError(
      errorId,
      `CRITICAL_RUNTIME_ERROR: ${error.message}`,
      window.location.pathname,
      this.props.userId || 'GUEST',
      {
        stack: error.stack,
        componentStack: errorInfo.componentStack
      }
    );
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-splash" style={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          background: '#0d1117',
          color: '#fff',
          fontFamily: 'system-ui, -apple-system, sans-serif',
          textAlign: 'center',
          padding: '20px'
        }}>
          <div style={{
            fontSize: '4rem',
            fontWeight: '800',
            background: 'linear-gradient(135deg, #ff375f 0%, #ffa116 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '10px'
          }}>500</div>
          <h1 style={{fontSize: '1.5rem', marginBottom: '20px'}}>SYSTEM_CRASH</h1>
          <p style={{color: '#8b949e', maxWidth: '500px', lineHeight: '1.6', marginBottom: '30px'}}>
            A critical exception occurred in the application layer. Our engineering team has been notified via the Error Daemon.
          </p>
          <div style={{
            background: 'rgba(255,255,255,0.05)',
            padding: '15px 30px',
            borderRadius: '12px',
            border: '1px solid rgba(255,255,255,0.1)',
            fontFamily: 'monospace',
            marginBottom: '30px'
          }}>
            <span style={{color: '#8b949e', marginRight: '10px'}}>ERROR_ID:</span>
            <code style={{color: '#ff375f'}}>{this.state.errorId || 'GENERATING...'}</code>
          </div>
          <button 
            onClick={() => window.location.href = '/'}
            style={{
              background: '#fff',
              color: '#000',
              border: 'none',
              padding: '12px 25px',
              borderRadius: '8px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'opacity 0.2s'
            }}
            onMouseOver={(e) => e.target.style.opacity = '0.8'}
            onMouseOut={(e) => e.target.style.opacity = '1'}
          >
            Restart Application
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
